import { createStore } from "solid-js/store";
import type { SimClock, SimTime } from "../types";


const DEFAULT_START: SimTime = { hour: 23, minute: 6, second: 20 };

const initialClock: SimClock = {
	currentTime: { ...DEFAULT_START },
	speedMultiplier: 1,
	isRunning: false,
};

const [clock, setClock] = createStore<SimClock>({ ...initialClock });

export function startClock() {
	setClock("isRunning", true);
}

export function pauseClock() {
	setClock("isRunning", false);
}

export function setClockTime(time: SimTime) {
	setClock("currentTime", time);
}

export function setSpeedMultiplier(speed: number) {
	setClock("speedMultiplier", speed);
}

export { clock, DEFAULT_START, setClock };
